export default "__VITE_ASSET__ByEVvDsS__"